<div id="considerTSAModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title flex-fill" [innerHTML]="'HOME.CONSIDER_TSA.CONSIDER_TSA_HEADER' | translate"></h4>
        <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <div class="chk-interview-ins">
          <span [innerHTML]="'HOME.CONSIDER_TSA.CONSIDER_TSA_STATEMENT' | translate"></span>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row row-link-group">

          <div class="col-12 col-lg-6">
            <a id="goToTSABtn" class="btn btn-primary d-block ttp-btn-centered" tabindex="0" data-bs-dismiss="modal" [innerHTML]="'HOME.CONSIDER_TSA.APPLY_TO_TSA' | translate"></a>
          </div>
          <div class="col-12 col-lg-6">
            <a id="proceedWithUPBtn" class="btn btn-primary d-block" style="white-space: normal; word-wrap: break-word;"  tabindex="0" data-bs-dismiss="modal" 
                  [innerHTML]="'HOME.CONSIDER_TSA.CONTINUE_WITH_GLOBAL_ENTRY' | translate"></a>
          </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
